<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'product',
})
</script>
<template>
<a-card title="产品管理">
   <lanseed-form-only ref="form" :data="searchVal" :rules="searchRule" :mode="false" @change="search">
    <template  #btn>
        <a-form-item>
        <a-button type="primary" v-if="auth.creating>0" @click="add"><PlusOutlined /> 新增 </a-button>
      </a-form-item>
    </template>
  </lanseed-form-only>
  <lanseed-form v-model:open="formshow" :data="formModel" :rules="formRole"  @change="submit"></lanseed-form>
  <a-table rowKey="ID"  :row-selection="rowselection"  :columns="columns" :dataSource="dataSource" :pagination="page" :loading="loading" @change="pageChange">
    <template #title>
      <div v-if="rowselection.selectedRowKeys.length>0&&auth.del>0"  class="padding flex align-center" style="width: 100%;">
        <span class="text-gray">共选择了<span class="text-primary text-bold padding-lr-sm">{{ rowselection.selectedRowKeys.length }}</span>条数据</span>
        <a-button type="primary" danger size="small" class="margin-left" @click="onDel">
        <DeleteOutlined  />  删除</a-button>
      </div>
    </template>
    <template #bodyCell="{column,record,index}">
      <a-button-group v-if="column.key=='action'">
            <a-button v-if="auth.edit>0" size="small" type="primary" @click="edit(record,index)">
                <EditOutlined /> 编辑
            </a-button>
      </a-button-group>
      <template v-if="column.key=='title'">
        <a-avatar shape="square" size="large" :src="addip(record.pic)" v-if="record.pic">
        </a-avatar> <span class="padding-left"> {{record.title}}</span>
      </template>
      <template v-if="column.key=='onoff'">
         <a-switch v-model:checked="record.onoff" checked-children="在线" un-checked-children="已下线" @change="onoff(record,index)" />
      </template>
    </template>
  </a-table>
</a-card>
</template>
<script setup lang="ts" name="product">
import api from '@/utils/http/service'
import { onMounted,ref,getCurrentInstance } from 'vue'
import {DeleteOutlined,PlusOutlined,EditOutlined} from   '@ant-design/icons-vue'
import LanseedFormOnly from '@/components/lanseed/formonly.vue'
import LanseedForm from '@/components/lanseed/form.vue'
import {message, notification} from 'ant-design-vue'
import {addip} from '@/utils/util'

const auth:any=api.auth()
const dataSource=ref<Array<any>>([])
const selectedIDS=ref<Array<any>>([])
const loading=ref<Boolean>(false)
const page=ref<Record<string,string>>({
  current:1,
  pageSize:10,
  total:0
})
const columns:Array<any>=[
  {title:'名称',dataIndex:'title',key:'title'},
  {title:'编号',dataIndex:'pno'},
  {title:'浏览次数',dataIndex:'readcount'},
  {title:'上下线',dataIndex:'onoff',key:'onoff'},
  {title:'操作',key:'action',},
]
const searchVal:Record=ref({
  keyword:''
})
const searchRule:Record=ref({
  keyword:{name:'关键字'},
  protype:{name:'类别',domtype:'select',data:[],map:{name:'title',value:'ID'}},
  time:{domtype:'datediff',name:'时间段',keys:['stime','etime']}
})
const rowselection:any=ref({
  fixed:true,
  selectedRowKeys:[],
  onChange:(e:any)=>{
    rowselection.value.selectedRowKeys=e
  }
})
const formModel:Record=ref({})
const formRole=ref({
  title:{name:'标题',required:true},
  pno:{name:'编号',desc:'不填写系统自动生成'},
  protype:{name:'类别',domtype:'select',required:true,data:[],map:{name:'title',value:'ID'}},
  subtitle:{name:'描述'},

  pic:{name:'图片',domtype:'img',max:10},
  contents:{domtype:'editor',name:'内容'},
  orders:{domtype:'number',name:'排序'},
  keywords:{domtype:'tags',name:'标签',desc:'用于用户搜索',max:3},
  attrs:{domtype:'keyvalue',name:'参数',rules:{title:{name:'名称'},value:{name:'值'}}},
  items:{domtype:'keyvalue',name:'型号',rules:{mode:{name:'名称'},money:{name:'售价',domtype:'number'}}}
})
const formshow=ref<Boolean>(false)
const protypes=ref<Array<any>>([])
const getDataList=():void=>{
  loading.value = true
  api.product.list({ pageIndex: page.value.current, pageSize: page.value.pageSize,...searchVal.value }).then(res => {
        loading.value = false
        if (res.state == 1) {
          let r = res.data
          r.data.map(e=>{
            e.onoff=e.onoff>0
          })
          page.value.current=r.pageIndex
          page.value.total=r.records
          dataSource.value = r.data
        }
      })
}
const search=(e):void=>{
  searchVal.value=e
  page.value.current=1
  getDataList()
}
const onoff=(item:any,i:number)=>{
  api.product.onoff(item.ID).then(res=>{
    if(res.state==1){
        dataSource.value[i].onoff=res.data>0
    }
  })
}
const pageChange=(e):void=>{
  page.value.current=e.current
  page.value.pageSize=e.pageSize
  getDataList()
}
const onDel=(item:any,index:number):void=>{
  api.product.dels(rowselection.value.selectedRowKeys).then(res => {
          if (res.state == 1) {
            message.success(res.message)
            getDataList()
          }
        })
}
const add=():void=>{
  formModel.value={ID:0,pic:[],onoff:1,protype:null,tips:0,
    title:'',contents:'',subtitle:'',orders:0,keywords:[],items:[],attrs:[]
  }
  formshow.value=true
}
const edit=(item,index):void=>{
  api.product.get(item.ID).then(res=>{
    if(res.state==1){
      formModel.value=res.data
      formshow.value=true
    }
  })

}
const submit=(e):void=>{
  e.attrs=JSON.parse(e.attrs)
  e.items=JSON.parse(e.items)
  if(e.attrs.lenth==0){
    notification.info('产品型号请至少添加一项')
    return false
  }
  api.product.add(e).then(res=>{

    if(res.state==1){
      if(e.ID==0){
        dataSource.value.unshift(res.data)
      }else{
        let index =dataSource.value.findIndex(f=>{return f.ID==e.ID})
        dataSource.value[index]=res.data
      }
      formshow.value=false
      formModel.value=null
    }
  })
}
onMounted(()=>{
  getDataList()
   api.protype.list({pageFlag:false}).then(res => {
        if (res.state == 1) {
          formRole.value.protype.data=res.data
          searchRule.value.protype.data=[...res.data,{ID:'',title:'不限'}]
          protypes.value = res.data
        }
   })
})
</script>
